/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	class MoveOriginalCustomGroupItemId extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 2004;
		}

		/**
		 * Perform upgrade to move "originalCustomGroupItemId" in dataItem to the source shaping references
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (spec && WidgetUpgradeUtils.specHasWidgets(spec)) {
				for (const widgetId in spec.widgets) {
					this._upgradeWidget(spec.widgets[widgetId], spec);
				}
			}
			return Promise.resolve(spec);
		}

		_upgradeWidget(model, spec) {
			_.each(model.data && model.data.dataViews, dataView => {
				const source = _.findWhere(spec.dataSources.sources, { id: dataView.modelRef } );
				this._setOriginalCustomGroupItemId(source, dataView.dataItems);
			});
		}

		_setOriginalCustomGroupItemId(source, dataItems) {
			// the source should be already shaped to have custom groups
			if (source && source.shaping) {
				_.each(dataItems, dataItem => {
					if (dataItem.originalCustomGroupItemId) {
						if (!source.shaping.references) {
							source.shaping.references = {};
						}
						// move the originalCustomGroupItemId to shaping references
						source.shaping.references[dataItem.itemId] = dataItem.originalCustomGroupItemId;
						// remove originalCustomGroupItemId from the dataItem model
						delete dataItem.originalCustomGroupItemId;
					}
				});
			}
		}

	}

	return new MoveOriginalCustomGroupItemId();

});
